<template>
  <div class="multi-community-fee-summary-container">
    <!-- 搜索栏 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('communityFeeSummary.multiCommunityFeeSummary.search.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="community-select-wrapper">
            <el-select
              v-model="searchForm.communityIds"
              multiple
              collapse-tags
              :placeholder="$t('communityFeeSummary.multiCommunityFeeSummary.search.placeholderCommunity')"
              class="w-100"
            >
              <el-option
                v-for="item in communityList"
                :key="item.communityId"
                :label="item.name"
                :value="item.communityId"
              />
            </el-select>
            <el-button
              size="mini"
              type="text"
              @click="toggleSelectAllCommunities"
              class="select-all-btn"
            >
              {{ isAllCommunitiesSelected ? '取消全选' : '全选' }}
            </el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="searchForm.monthRange"
            type="monthrange"
            :placeholder="$t('communityFeeSummary.multiCommunityFeeSummary.search.placeholderMonthRange')"
            format="yyyy-MM"
            value-format="yyyy-MM"
            class="w-100"
          />
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="searchForm.configIds"
            multiple
            collapse-tags
            :placeholder="$t('communityFeeSummary.multiCommunityFeeSummary.search.placeholderFeeType')"
            class="w-100"
          >
            <el-option
              v-for="item in feeTypeOptions"
              :key="item.statusCd"
              :label="item.name"
              :value="item.statusCd"
            />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="searchForm.state"
            clearable
            :placeholder="$t('communityFeeSummary.multiCommunityFeeSummary.search.placeholderFeeState')"
            class="w-100"
          >
            <el-option :label="$t('communityFeeSummary.multiCommunityFeeSummary.search.stateWait')" value="W" />
            <el-option :label="$t('communityFeeSummary.multiCommunityFeeSummary.search.stateComplete')" value="C" />
            <el-option :label="$t('communityFeeSummary.multiCommunityFeeSummary.search.stateRefund')" value="R" />
          </el-select>
        </el-col>
        <el-col :span="4" class="text-right">
          <el-button type="primary" @click="handleSearch">{{ $t('communityFeeSummary.multiCommunityFeeSummary.search.search') }}</el-button>
          <el-button @click="handleReset">{{ $t('communityFeeSummary.multiCommunityFeeSummary.search.reset') }}</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- Tab 切换 -->
    <el-card class="box-card mt-20">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane
          :label="$t('communityFeeSummary.multiCommunityFeeSummary.tab.byCommunity')"
          name="byCommunity"
        >
          <!-- 按小区汇总表格 -->
          <el-table :data="summaryData" border style="width: 100%" v-loading="loading">
            <el-table-column
              prop="communityId"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.communityName')"
              align="center"
              min-width="140"
              fixed="left"
            >
              <template slot-scope="scope">
                {{ communityMap[scope.row.communityId] || scope.row.communityId }}
              </template>
            </el-table-column>
            <el-table-column
              prop="totalRoomCount"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.totalRoomCount')"
              align="center"
              width="90"
            />
            <el-table-column
              prop="feeRoomCount"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.feeRoomCount')"
              align="center"
              width="90"
            />
            <el-table-column
              prop="oweRoomCount"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.oweRoomCount')"
              align="center"
              width="90"
            />
            <el-table-column
              prop="hisOweFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.hisOweFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.hisOweFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="curReceivableFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.curReceivableFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.curReceivableFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="curReceivedFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.curReceivedFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.curReceivedFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="curOweFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.curOweFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.curOweFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="totalOweFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.totalOweFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.totalOweFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="actualPaid"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.actualPaid')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.actualPaid) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="feeRoomRate"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.feeRoomRate')"
              align="center"
              width="110"
            >
              <template slot-scope="scope">
                <span :style="{ color: getRateColor(scope.row.feeRoomRate) }">
                  {{ formatRate(scope.row.feeRoomRate) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="feeRate"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.feeRate')"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <span :style="{ color: getRateColor(scope.row.feeRate) }">
                  {{ formatRate(scope.row.feeRate) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="clearRate"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.clearRate')"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <span :style="{ color: getRateColor(scope.row.clearRate) }">
                  {{ formatRate(scope.row.clearRate) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            class="mt-10 text-right"
            @size-change="handleSummarySizeChange"
            @current-change="handleSummaryCurrentChange"
            :current-page="summaryPagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="summaryPagination.row"
            layout="total, sizes, prev, pager, next, jumper"
            :total="summaryPagination.total"
          />
          <div class="text-right mt-10">
            <el-button type="success" @click="handleExport">{{ $t('communityFeeSummary.multiCommunityFeeSummary.export') }}</el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane
          :label="$t('communityFeeSummary.multiCommunityFeeSummary.tab.byDetail')"
          name="byDetail"
        >
          <!-- 按明细汇总表格 -->
          <el-table :data="detailData" border style="width: 100%" v-loading="loading">
            <el-table-column
              prop="communityId"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.communityName')"
              align="center"
              min-width="140"
            >
              <template slot-scope="scope">
                {{ communityMap[scope.row.communityId] || scope.row.communityId }}
              </template>
            </el-table-column>
            <el-table-column
              prop="feeName"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.feeName')"
              align="center"
              min-width="120"
            />
            <el-table-column
              prop="detailYear"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.year')"
              align="center"
              width="80"
            />
            <el-table-column
              prop="detailMonth"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.month')"
              align="center"
              width="80"
            />
            <el-table-column
              prop="receivableAmountTotal"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.receivableAmountTotal')"
              align="right"
              min-width="140"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.receivableAmountTotal) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="receivedAmountTotal"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.receivedAmountTotal')"
              align="right"
              min-width="140"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.receivedAmountTotal) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="oweAmountTotal"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.oweAmountTotal')"
              align="right"
              min-width="140"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.oweAmountTotal) }}
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            class="mt-10 text-right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.row"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          />
          <div class="text-right mt-10">
            <el-button type="success" @click="handleExport">{{ $t('communityFeeSummary.multiCommunityFeeSummary.export') }}</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { queryReportCommunityFeeSummary, queryReportCommunityFeeSummaryDetail } from '@/api/report/multiCommunityFeeSummaryApi'
import { getMyEnteredCommunitys } from '@/api/community/communityApi'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
  name: 'MultiCommunityFeeSummaryList',
  data() {
    return {
      activeTab: 'byCommunity',
      searchForm: {
        communityIds: [],
        monthRange: [],
        configIds: [],
        state: '',
        feeTypeCds: []
      },
      communityList: [],
      communityMap: {},
      isAllCommunitiesSelected: false,
      feeTypeOptions: [],
      summaryData: [],
      detailData: [],
      loading: false,
      summaryPagination: {
        page: 1,
        row: 20,
        total: 0
      },
      pagination: {
        page: 1,
        row: 20,
        total: 0
      }
    }
  },
  created() {
    this.loadCommunities()
    this.loadFeeTypes()
  },
  watch: {
    'searchForm.communityIds'(val) {
      this.isAllCommunitiesSelected = this.communityList.length > 0 && val.length === this.communityList.length
    }
  },
  methods: {
    async loadCommunities() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 500 })
        this.communityList = res.communitys || []
        this.communityMap = {}
        this.communityList.forEach(c => {
          this.$set(this.communityMap, c.communityId, c.name)
        })
      } catch (error) {
        console.error('Failed to load communities:', error)
      }
    },
    loadFeeTypes() {
      this.$store.dispatch('dict/getDict', {
        dictType: 'pay_fee_config',
        dictName: 'fee_type_cd'
      }).then(data => {
        this.feeTypeOptions = data
      })
    },
    buildParams() {
      const params = {
        communityIds: this.searchForm.communityIds ? this.searchForm.communityIds.join(',') : '',
        startDate: this.searchForm.monthRange ? this.searchForm.monthRange[0] : '',
        endDate: this.searchForm.monthRange ? this.searchForm.monthRange[1] : '',
        configIds: this.searchForm.configIds ? this.searchForm.configIds.join(',') : '',
        feeTypeCds: this.searchForm.feeTypeCds ? this.searchForm.feeTypeCds.join(',') : '',
        state: this.searchForm.state,
        page: this.pagination.page,
        row: this.pagination.row
      }
      return params
    },
    async handleSearch() {
      this.pagination.page = 1
      this.summaryPagination.page = 1
      await this.fetchData()
    },
    handleReset() {
      this.searchForm = {
        communityIds: [],
        monthRange: [],
        configIds: [],
        state: '',
        feeTypeCds: []
      }
      this.isAllCommunitiesSelected = false
      this.summaryPagination = { page: 1, row: 20, total: 0 }
      this.pagination = { page: 1, row: 20, total: 0 }
      this.summaryData = []
      this.detailData = []
    },
    toggleSelectAllCommunities() {
      if (this.isAllCommunitiesSelected) {
        this.searchForm.communityIds = []
        this.isAllCommunitiesSelected = false
      } else {
        this.searchForm.communityIds = this.communityList.map(c => c.communityId)
        this.isAllCommunitiesSelected = true
      }
    },
    async fetchData() {
      try {
        this.loading = true
        if (this.activeTab === 'byCommunity') {
          const params = this.buildParams()
          params.page = this.summaryPagination.page
          params.row = this.summaryPagination.row
          const res = await queryReportCommunityFeeSummary(params)
          if (res.data && res.data.code === 0) {
            this.summaryData = res.data.data || []
            this.summaryPagination.total = res.data.total || 0
          }
        } else {
          const params = this.buildParams()
          params.page = this.pagination.page
          params.row = this.pagination.row
          const res = await queryReportCommunityFeeSummaryDetail(params)
          if (res.data && res.data.code === 0) {
            this.detailData = res.data.data || []
            this.pagination.total = res.data.total || 0
          }
        }
      } catch (error) {
        this.$message.error(this.$t('communityFeeSummary.multiCommunityFeeSummary.fetchError'))
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleTabClick() {
      this.summaryPagination.page = 1
      this.pagination.page = 1
      this.fetchData()
    },
    handleSummarySizeChange(val) {
      this.summaryPagination.row = val
      this.summaryPagination.page = 1
      this.fetchData()
    },
    handleSummaryCurrentChange(val) {
      this.summaryPagination.page = val
      this.fetchData()
    },
    handleSizeChange(val) {
      this.pagination.row = val
      this.pagination.page = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchData()
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(2)
    },
    formatRate(value) {
      return (Number(value || 0).toFixed(2)) + '%'
    },
    getRateColor(rate) {
      if ((rate || 0) >= 90) return '#67C23A'
      if ((rate || 0) >= 60) return '#E6A23C'
      return '#F56C6C'
    },
    async handleExport() {
      this.loading = true
      try {
        if (this.activeTab === 'byCommunity') {
          await this.exportSummaryData()
        } else {
          await this.exportDetailData()
        }
      } catch (error) {
        this.$message.error('导出失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async exportSummaryData() {
      // 请求全部数据（不分页）
      const params = this.buildParams()
      params.page = 1
      params.row = 99999
      const res = await queryReportCommunityFeeSummary(params)
      if (!res.data || res.data.code !== 0 || !res.data.data || res.data.data.length === 0) {
        this.$message.warning('没有数据可导出')
        return
      }
      const headers = [
        '小区名称', '总户数', '收费户数', '欠费户数',
        '历史欠费', '当期应收', '当期实收', '当期欠费', '总欠费', '实缴',
        '户收费率', '收费率', '清缴率'
      ]
      const data = res.data.data.map(row => [
        this.communityMap[row.communityId] || row.communityId,
        row.totalRoomCount || 0,
        row.feeRoomCount || 0,
        row.oweRoomCount || 0,
        this.formatMoney(row.hisOweFee),
        this.formatMoney(row.curReceivableFee),
        this.formatMoney(row.curReceivedFee),
        this.formatMoney(row.curOweFee),
        this.formatMoney(row.totalOweFee),
        this.formatMoney(row.actualPaid),
        this.formatRate(row.feeRoomRate),
        this.formatRate(row.feeRate),
        this.formatRate(row.clearRate)
      ])
      this.downloadExcel([headers, ...data], '按小区费用汇总')
    },
    async exportDetailData() {
      // 请求全部数据（不分页）
      const params = this.buildParams()
      params.page = 1
      params.row = 99999
      const res = await queryReportCommunityFeeSummaryDetail(params)
      if (!res.data || res.data.code !== 0 || !res.data.data || res.data.data.length === 0) {
        this.$message.warning('没有数据可导出')
        return
      }
      const headers = [
        '小区名称', '费用名称', '年份', '月份',
        '应收金额', '实收金额', '欠费金额'
      ]
      const data = res.data.data.map(row => [
        this.communityMap[row.communityId] || row.communityId,
        row.feeName,
        row.detailYear,
        row.detailMonth,
        this.formatMoney(row.receivableAmountTotal),
        this.formatMoney(row.receivedAmountTotal),
        this.formatMoney(row.oweAmountTotal)
      ])
      this.downloadExcel([headers, ...data], '费用明细汇总')
    },
    downloadExcel(data, fileName) {
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([wbout], { type: 'application/octet-stream' })
      saveAs(blob, fileName + '.xlsx')
    }
  }
}
</script>

<style lang="scss" scoped>
.multi-community-fee-summary-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .w-100 {
    width: 100%;
  }

  .text-right {
    text-align: right;
  }

  .community-select-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    .el-select {
      flex: 1;
    }

    .select-all-btn {
      position: absolute;
      right: 30px;
      z-index: 10;
      padding: 0;
      font-size: 12px;
    }
  }
}
</style>
